var include_footer = `
</div>
<div class="totop">
	<a id="js-totop" class="totop-link"></a>
</div>
<footer class="footer">
	<div class="footer-wrap">
		<div class="footer-main footer-main--icon">
			<div class="footer-logo">
				<img src="/material/img/common/logo/logo_footer.png" width="100%" alt="" class="sp-img160">
					<div class="footer-icon">
						<a href="https://twitter.com/nanacoPR" target="_blank" class="twitter__footer-icon"><img src="/material/img/common/icon/icon_twitter_circle.png" width="100%" alt=""></a>
						<a href="https://line.me/ti/p/%407card" target="_blank"><img src="/material/img/common/icon/icon_line_circle.png" width="100%" alt=""></a>
						<a href="/cp/mailmagazine/" class="sp-only"><img src="/material/img/common/icon/icon_mail_circle.png" width="100%" alt=""></a>
					</div>
					<div class="pc-only footer-icon footer-icon--mt">
						<a href="/cp/mailmagazine/"><img src="/material/img/common/icon/icon_mail_circle.png" width="100%" alt=""></a>
					</div>
				</div>
			<div class="footer-inner pc-only">
				<div class="footer-group">
					<ul class="footer-list">
						<li><a href="/app/" class="Nanaco_CmnFooter footer-list__link footer-list__link--blank" target="_blank">「Apple Payのnanaco」特設ページ</a></li>
					</ul>
					<ul class="footer-list">
						<li><a href="/introduction/" class="Nanaco_CmnFooter">nanacoとは</a></li>
					</ul>
					<ul class="footer-list">
						<li><a href="/entry/" class="Nanaco_CmnFooter">お申し込み方法</a></li>
						<li class="footer-list__item footer-list__item--level02">nanacoカード</li>
						<ul class="footer-list footer-list--level03-type02">
							<li class="footer-list__item footer-list__item--level04"><a href="/entry/nyukai_shop.html" class="footer-list__link Nanaco_CmnFooter">店頭でのお申し込み方法</a></li>
							<li class="footer-list__item footer-list__item--level04"><a href="/entry/nyukai_web.html" class="footer-list__link Nanaco_CmnFooter">WEB申込書を作成する方法</a></li>
						</ul>
						<li class="footer-list__item footer-list__item--level02">nanacoモバイル</li>
						<ul class="footer-list footer-list--level03-type02">
							<li class="footer-list__item footer-list__item--level04"><a href="/app/" class="footer-list__link footer-list__link--blank Nanaco_CmnFooter" target="_blank">Apple Payのnanaco</a></li>
							<li class="footer-list__item footer-list__item--level04"><a href="/entry/download_sp.html" class="footer-list__link Nanaco_CmnFooter">nanacoモバイル for Android</a></li>
						</ul>
						<li class="footer-list__item footer-list__item--level02">nanaco一体型クレジットカード<br>セブンカード・プラス</li>
						<ul class="footer-list footer-list--level03-type02">
							<li class="footer-list__item footer-list__item--level04"><a href="https://www.7card.co.jp/lp/plus/nnchp02.html?link_id=inc_footer" class="footer-list__link footer-list__link--blank Nanaco_CmnFooter Nanaco_Lead7cardLink CvFooter_01" target="_blank">セブンカード・プラス</a></li>
						</ul>
					</ul>
				</div>
				<div class="footer-group">
					<ul class="footer-list">
						<li>
							<a href="/how-to/" class="Nanaco_CmnFooter">使い方</a>
							<ul class="footer-list footer-list--level03">
								<li class="footer-list__item footer-list__item--level04"><a href="/how-to/charge/" class="footer-list__link Nanaco_CmnFooter">チャージ（入金）する</a></li>
								<li class="footer-list__item footer-list__item--level04"><a href="/how-to/payment/" class="footer-list__link Nanaco_CmnFooter">支払う</a></li>
								<li class="footer-list__item footer-list__item--level04"><a href="/how-to/save_point/" class="footer-list__link Nanaco_CmnFooter">ポイントをためる</a></li>
								<li class="footer-list__item footer-list__item--level04"><a href="/how-to/use_point/" class="footer-list__link Nanaco_CmnFooter">ポイントを使う</a></li>
								<li class="footer-list__item footer-list__item--level04"><a href="/how-to/exchange_point/" class="footer-list__link Nanaco_CmnFooter">他のポイントをnanacoポイントに交換する</a></li>
								<li class="footer-list__item footer-list__item--level04"><a href="/how-to/menu/" class="footer-list__link Nanaco_CmnFooter">nanaco会員メニューの使い方</a></li>
								<li class="footer-list__item footer-list__item--level04"><a href="/how-to/gift/" class="footer-list__link Nanaco_CmnFooter">nanacoギフト</a></li>
							</ul>
						</li>
					</ul>
				</div>
				<div class="footer-group">
					<ul class="footer-list">
						<li><a href="/alliance/" class="Nanaco_CmnFooter">使えるお店</a></li>
					</ul>
					<ul class="footer-list">
						<li><a href="/cp/" class="Nanaco_CmnFooter">キャンペーン</a></li>
					</ul>
					<ul class="footer-list">
						<li><a href="/cp/#mail_sns" class="Nanaco_CmnFooter">メールマガジン・SNS情報</a></li>
					</ul>
					<ul class="footer-list">
						<li>
							<a href="/support/" class="Nanaco_CmnFooter">お客様サポート</a>
							<ul class="footer-list footer-list--level03">
								<li class="footer-list__item footer-list__item--level04"><a href="/support/rescue.html" class="footer-list__link Nanaco_CmnFooter">紛失・盗難のお手続き</a></li>
								<li class="footer-list__item footer-list__item--level04"><a href="/support/malfunction.html" class="footer-list__link Nanaco_CmnFooter">不具合・故障のお手続き</a></li>
								<li class="footer-list__item footer-list__item--level04"><a href="/support/change/" class="footer-list__link Nanaco_CmnFooter">機種変更のお手続き</a></li>
								<li class="footer-list__item footer-list__item--level04"><a href="https://secure.okbiz.jp/7card/?site_domain=nanaco" class="footer-list__link Nanaco_CmnFooter">よくあるご質問</a></li>
								<li class="footer-list__item footer-list__item--level04"><a href="/support/contact.html" class="footer-list__link Nanaco_CmnFooter">nanacoお問合せセンター</a></li>
							</ul>
						</li>
					</ul>
					<ul class="footer-list">
						<li><a href="/information/" class="Nanaco_CmnFooter">お知らせ・ニュースリリース</a></li>
					</ul>
					<ul class="footer-list">
						<li><a href="/biz/" class="Nanaco_CmnFooter">法人のお客様</a></li>
					</ul>
					<ul class="footer-list">
						<li><a href="https://www.7card.co.jp/qpnanaco/index.html?_ebx=42k8wgfmm.1561334026.79te3wj" class="footer-list__link footer-list__link--blank Nanaco_CmnFooter" target="_blank">QUICPay(nanaco)</a></li>
					</ul>
				</div>
			</div>
		</div>
		<div class="footer-navi">
			<ul class="footer-navi__list">
				<li class="footer-navi__item footer-navi__item--grid2"><a href="/terms/" class="footer-navi__link Nanaco_CmnFooter">nanaco会員規約・特約</a></li>
				<li class="footer-navi__item footer-navi__item--grid2"><a href="https://www.7card.co.jp/company/priv.html" class="footer-navi__link footer-navi__link--blank Nanaco_CmnFooter" target="_blank">個人情報保護方針</a></li>
				<li class="footer-navi__item"><a href="/sitepolicy/" class="footer-navi__link Nanaco_CmnFooter">サイトのご利用について</a></li>
				<li class="footer-navi__item"><a href="https://www.7card.co.jp/company/com/" class="footer-navi__link footer-navi__link--blank Nanaco_CmnFooter" target="_blank">運営会社案内</a></li>
				<li class="footer-navi__item"><a href="/sitemap/" class="footer-navi__link Nanaco_CmnFooter">サイトマップ</a></li>
			</ul>
		</div>
	</div>
	<div class="copy-wrap">
		<div class="copy">
			<div class="copy-logo"></div>
			<div class="copy-text">Copyright&copy; Seven Card Service Co., Ltd. All Rights Reserved.</div>
		</div>
	</div>
</footer>
</div>
`;
